module.exports = __webpack_public_path__ + "media/store/images/icon-buttons/column-1-1df4b4847bc03ffa65b9362cd6470d06.svg";